<!-- =========================================================================================
  File Name: speed.vue
  Description: Setting Speed
========================================================================================== -->

<template>
  <div id="setting-speed">

    <vx-card title="线路设置">
      <div slot="actions">
        <vs-button color="success" size="small" type="filled" @click="add">添加线路</vs-button>
      </div>
      <vs-table stripe :data="list" noDataText="暂无线路">
        <template slot="thead">
          <vs-th width="300">名称</vs-th>
          <vs-th width="300">类型</vs-th>
          <vs-th>地址</vs-th>
          <vs-th width="300">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.name">
              <vs-input v-model="item.name" class="w-full" />
            </vs-td>
            <vs-td :data="item.type">
              <vs-select class="w-full" v-model="list[index].type">
                <vs-select-item :value="index2" :text="item2" v-for="(item2, index2) in type" :key="index2" />
              </vs-select>
            </vs-td>
            <vs-td :data="item.url">
              <vs-input v-model="item.url" class="w-full" />
            </vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index" :data-cmd="item.id == -1 ? 'add' : 'mod'">{{item.id == -1 ? '添加' : '更改'}}</vs-button>
              <vs-button color="danger" type="border" size="small" @click="modify" :data-index="index" data-cmd="del" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-button class="mt-5" color="success" type="filled" @click="add">添加线路</vs-button>

    </vx-card>

  </div>
</template>

<script>

export default {
  data() {
    return {
      list: [],
      type: []
    }
  },
  methods: {
    modify (e) {
      const dataset = e.currentTarget.dataset
      const postdata = this.list[dataset.index]
      postdata.authKey = localStorage.getItem('authKey')
      postdata.cmd = dataset.cmd
      // 如果是删除，则需要确认
      if (postdata.cmd == 'del') {
        // 如果还没添加，则直接删除
        if (postdata.id == -1) {
          this.list.splice(dataset.index, 1)
          return
        }
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '确认',
          text: '确认删除本条线路信息吗?',
          acceptText: '确认',
          cancelText: '取消',
          accept: () => {
            this.modifyRequest(postdata)
          }
        })
      } else {
        this.modifyRequest(postdata)
      }
    },
    modifyRequest (postdata) {
      this.$utils.post('setting-speedDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
      })
    },
    add () {
      this.list.push({ id: -1 })
    },
    load () {
      this.$utils.post('setting-speedList', { authKey: localStorage.getItem('authKey') }).then(res => {
        this.list = res.list
        this.type = res.type
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
